import React, { useState, useEffect , useRef} from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'

import axios from "axios";
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearchMinus, faSearchPlus,
    faArrowUp, faArrowDown, faArrowLeft, faArrowRight,
    faSearch, faAngleUp, faAngleDown, faTimes } from '@fortawesome/free-solid-svg-icons';
import Responser from "./ResponseGeneration.js"
import './nlp/nlp.css';
import nlp from './nlp/nlp_pdf_adl.js';
import frm from './formAux.js'

function isstring(o) { return typeof (o) == 'string'; }
function isarray(o) { return o instanceof Array; }
function isobj(o) { return o != null && o instanceof Object && !(o instanceof Array); }
function clone(o) { return JSON.parse(JSON.stringify(o)); }

const originalError = console.error;
console.error = function(error) {
    console.log('erox', error)
  // Parse the error here
  // ...
  if( error instanceof Object && error.message && error.message.toString().match(/failed.*fetch/i) ) {
    frm.myAlert('Fetch Error', 'There was an error fetching the object. Plese check the CORS policy for the source object')
  }
  console.log( 'CONSOLEERROR', error  )
  // Call the original console.error() function to log the error to the console
  originalError.apply(console, arguments);
};

/*
https://labeling-datasets.s3.ap-south-1.amazonaws.com/output/Home-Appliance-Job-3/manifests/output/output.manifest
s3://labeling-datasets/output/kitti-bounding-box-audit/manifests/output/output.manifest
*/

function taskNav()
{
    var tlist = window.GlobalVars.taskList;
    var tname = 'Task'
    if( datasetDetail ) {
        $('.top-nav').html('<button class="wizz1">Back to Dataset</button>');
        // $('.top-nav').remove();
        // return;
        tlist = window.GlobalVars.itemList;
        tname = 'Item';
        $('.top-nav').find('button').on('click', function(){
            window.goPage('datasetItems');
        })
    }
    if( !tlist ) return;
    var nav = $('<div class="task-spacer"></div><div class="task-nav"><i class="fa fa-step-backward first"></i><i class="fa fa-backward prev"></i><span class="task-pos"></span><i class="fa fa-forward next"></i><i class="fa fa-step-forward last"></i></div>');
    if( $('.top-nav').html() == '')$('.top-nav').append( $('<button>') );
    $('.top-nav').append( nav );
    
    var len = tlist.list.length;
    var pos = tlist.idx+1;
    $('.task-pos').text( tname + ' '+pos+' of '+len );  // modifytask to Task 22/12 mani
    nav.find('I').on('click', function(){
        var npos = 0;
        if( $(this).hasClass('prev') ) npos = pos-2;
        else if( $(this).hasClass('next') ) npos = pos;
        else if( $(this).hasClass('last') ) npos = len-1;
        if( npos < 0 ) npos = 0;
        var nextFile = null;
        // if( tlist.list[npos] ) nextFile = tlist.list[npos].fileId;
        // alert( npos )
        if( tlist.list[npos] ) nextFile = tlist.list[npos];
        if( nextFile )
        {
            var params = window.getParams();
            if( datasetDetail ) {
                params.itemId = nextFile;
                delete params.fileId;
                delete window.GlobalVars.PDFFileId;
                window.GlobalVars.PDFItemId = nextFile;
            } else {
                params.fileId = nextFile;
                window.GlobalVars.PDFFileId = nextFile;
            }
            tlist.idx = npos;
            window.saveSession( function(){
                window.goPage( window.getPage(1), params ) 
            } );
            return;
        }
        window.saveSession();
        window.goPage(backPage,window.getParams())
    })
}

var backPage = 'nlpBrowse';
var submitted = false;
var resumeLaterTid = null;


function valueIn( v, list ) {
    return list.indexOf(v) != -1;
}
// Function to parse filename and extract title and theme (Provided by user)
function parseFilenameForTitleAndTheme(filename) {
    if (!filename) return { title: null, theme: null };

    // Remove file extension
    const nameWithoutExtension = filename.replace(/\.[^/.]+$/, "");

    // Split by underscores
    const parts = nameWithoutExtension.split('_');

    // Check if we have at least 3 parts (imagename_title_theme)
    if (parts.length >= 3) {
        const title = parts[1];
        const theme = parts[2];

        // Return title and theme if they exist and are not empty
        if (title && title.trim() !== '' && theme && theme.trim() !== '') {
            return {
                title: title.trim(),
                theme: theme.trim()
            };
        }
    }

    return { title: null, theme: null };
}

// Removed the createTitleThemeDisplay function as it's no longer needed
// because the NLP library handles rendering metadata

var initTid = null;

var datasetDetail = false;

function NlpViewer(prop) {
    const responserRef = useRef();
    const [utterancedata, utterancesetData] = useState(null);
    const [allPrompts, setAllPrompts] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    
    const [descriptorTasker, setDescriptorTasker] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        const intervalId = setInterval(() => {
            if (!isInitialized || !responserRef.current || !window.Utterancedata?.descriptor) {
                return;
            }
            
            if (window.GlobalVars?.isResetForAudio === true) {
                console.log("Global reset flag detected! Orchestrating full task reset.");

                // 1. Command the child to perform its internal data reset.
                // This clears the descriptor.responseProject array.
                responserRef.current.resetCurrentForm();

                // 2. Reset the parent's state to match.
                setCurrentIndex(0);

                // 3. Update the global descriptor's progress tracker.
                window.Utterancedata.descriptor.taskcomplete = 0;

                // 4. Save all these changes to the backend.
                // The child's reset function already calls this, but an extra call here ensures
                // the taskcomplete=0 change is also saved.
                if (typeof window.updateAnnotations === 'function') {
                    window.updateAnnotations();
                }

                // 5. Consume the flag to prevent repeated resets.
                window.GlobalVars.isResetForAudio = false;
                
                // 6. Persist the consumed flag state.
                if (window.saveSession) {
                    window.saveSession();
                } else if (localStorage) {
                    localStorage.setItem('session', JSON.stringify(window.GlobalVars));
                }
                
                console.log("Full task reset complete. Current index is 0.");
            }
        }, 1000)
        return () => clearInterval(intervalId);
    }, [isInitialized]); 

    useEffect( function(a){
        let params = window.getParams();
        if( params.ptype == 'datasetDetail') {
            datasetDetail = true;
        }
        window.nlp = nlp;
    
        if(window.GlobalVars.PDFProjectType === 'Classification'){
            $('#showSummary').hide();
        }

        // alert( window.GlobalVars.PDFRole );
        if( window.GlobalVars.PDFRole ) backPage = 'nlpJobs';
        window.setNavActive(backPage);
        var fileId = window.GlobalVars.PDFFileId;
        var itemId = fileId ? null : window.GlobalVars.PDFItemId;
        // var myId = window.GlobalVars.userId || window.GlobalVars.workerId;
        var myId = window.GlobalVars.userId;
        var myEmail = window.GlobalVars.userEmail;


        function resumeLater() {
            console.log( 'resumeLater', nlp.updating() )
            clearTimeout( resumeLaterTid )
            if( !nlp.updating() ) {
                setTimeout( function(){window.goPage(backPage,window.getParams());}, 500 );
            }
            else resumeLaterTid = setTimeout( resumeLater, 500 );
        }
        $('#resumeLater').on('click', function(){
            if( deepLinkResult() ) return;
            resumeLater();
        });                                                         

        function submitAnnotations( obj )
        {
            if (window.GlobalVars.PDFProjectType === 'Response Generation' && responserRef.current && obj?.taskDeclined === undefined) {
                if (!responserRef.current.validateDropdowns()) {
                    return;
                }
            }
            if( submitted ) return;
            submitted = true;
            setTimeout( function() { submitted = false}, 5000 )
            console.log( 'SUBMIT', obj )
            window.post( 'save_annotation', {
                fileId:fileId,
                myId:myId,
                annotations:obj,
                target:'final',
                role:window.GlobalVars.PDFRole
            }, function(res){
                if( window.GlobalVars.taskList )
                {
                    var tlist = window.GlobalVars.taskList;
                    // if( tlist.list[tlist.idx+1] ) tlist.next = tlist.list[tlist.idx+1].fileId;
                    if( tlist.list[tlist.idx+1] ) tlist.next = tlist.list[tlist.idx+1];
                    else tlist.next = 'next';
                    window.saveSession();
                }
                if( deepLinkResult() ) return;
                window.goPage(backPage,window.getParams())
                console.log( 'submited' );
            });
        }

        function deepLinkResult() {
            if( window.GlobalVars.deepLinkReturnURL ) {
                var a = $('<a target="_top">').attr('href', window.GlobalVars.deepLinkReturnURL );
                $(document.body).append(a);
                a[0].click();
                return true;
            } 
            return false;
        }

        function updateAnnotations( obj, callback )
        {
            console.log( 'UPDATE', obj );

            window.post( 'save_annotation', {
                fileId:fileId,
                myId:myId,
                myEmail:myEmail,
                annotations:obj,
                target:'tmp',
                role:window.GlobalVars.PDFRole,
                utterance: window.Utterancedata
            }, function(res){
                console.log( 'SAVE_ANNOTATION', res )
                if( callback ) callback(res);
            });
        }
        window.updateAnnotations = updateAnnotations;
        // var modal = $('<div id="myModal" class="modal fade" role="dialog" style="z-index: 100000">').html('<div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close myclose" data-dismiss="modal">&times;</button><h4 class="modal-title">Modal Header</h4></div><div class="modal-body"><p>Some text in the modal.</p></div><div class="modal-footer"><button type="button" id="modal-close" class="btn btn-secondary" data-dismiss="modal">Close</button><button type="button" id="modal-close2" class="btn btn-secondary" data-dismiss="modal">Close</button><button type="button" id="modal-close3" class="btn btn-secondary" data-dismiss="modal">Close</button></div></div></div>');
        // $(document.body).prepend(modal);
        // console.log( 'LOADFILE', {fileId:fileId,myId:myId} )

        var claimWait = false;
        async function claimCallback(descriptor) {
            descriptor.task_auto_claim = false;
            if (claimWait) return;

            claimWait = true;
            let res = await window.post('claim_task', { fileId: fileId });
            console.log('CLAIM', res.data)
            if (!res.data) {
                return frm.myAlert('Claim Error', "You cant't claim this task")
            }
            if (descriptor.task_orig_state > 1 && descriptor.task_orig_state != 7 && !descriptor.disableQC) {
                descriptor.reviewMode = 1;
            }
            descriptor.blockEdit = false;
            if(window.GlobalVars.PDFProjectType === 'Response Generation') {
                console.log("claimCallback: Setting currentIndex to 0 for Response Generation project.");
                console.log(descriptor);
                 setDescriptorTasker({ ...descriptor, blockEdit: false });
            }
            descriptor.fixButtons(descriptor);
            claimWait = false;
        }

        async function releaseCallback(descriptor) {
            frm.myAlert('Release Task', "By releasing the task, any temporary annotations you've made will be lost. Are you sure?", "Ok", release, "Cancel");
            function release() {
                window.post('release_task', { fileId: fileId, myId: myId }, function (res) {
                    console.log('RELEASE', res.data, descriptor)
                    if (!res.data) {
                        return frm.myAlert('Release Error', "You cant't release this task")
                    }
                    if (descriptor.task_orig_state > 1) {
                        descriptor.reviewMode = false;
                    }
                    descriptor.blockEdit = true;
                    descriptor.task_can_claim = true;
                    descriptor.fixButtons(descriptor);
                    window.goPage(backPage,window.getParams());
                })
            }
        }

        setTimeout( taskNav, 1 );
        nlp.loading('loading task data');
        let loadPayload = {fileId:fileId,myId:myId,itemId:itemId}
        if( params.modelRun ) loadPayload.modelRun = params.modelRun;
        window.post( 'load_file', loadPayload, async function(res){
            console.log( 'LOAD_FILE', res.data );
            window.Utterancedata = res.data
            // return;
            if( !res.data ) {
                return error();
            }
            function error() {
                // return frm.myAlert( 'Task Error', 'An error ocourred loading this task.', 'Ok', function(){ window.goPage(backPage)} );
                return window.goPage(backPage,window.getParams());
            }
            try {
                var file = res.data;
                let title = 'Project: <span>' + file.projectName + '</span>';
                const truncateWords = (str, n) => str?.length > n ? str.slice(0, n) + "..." : str;
                if( !file.projectName ) title = 'Dataset Item: <span>'+truncateWords(file.name, 30)+'</span>'
                $('#pageTitle').html(title);
                const { title: fileTitle, theme: fileTheme } = parseFilenameForTitleAndTheme(file.name);
                var descriptor = file.descriptor;
                if( file.tags ) descriptor.tags = file.tags;
                descriptor.popTextEditLayout = 1;
                
                descriptor.text_attributes = {tags:[],links:[]};
                delete descriptor.text_attributes_url;
                delete descriptor.preloadData;
                delete descriptor.batchMode;
                delete descriptor.AWS;
                
                if( file.projectType == 'Classification' )
                {
                    delete descriptor.labels;
                    delete descriptor.relationships;
                    delete descriptor.boxes;
                    delete descriptor.attributes;
                    delete descriptor.pageAttributes;
                    delete descriptor.allowTextMode;
                }
                else {
                    delete descriptor.classification;
                    // alert( file.projectType )
                    if( file.projectType == 'Comprehend NER' || file.projectType == 'OCR' || file.comprehendData )
                    {
                        // delete descriptor.relationships;
                        delete descriptor.boxes;
                        if( !file.comprehendData ) file.comprehendData = {};
                        descriptor.comprehendMode = true;
                        descriptor.comprehendExport = false;
                        descriptor.selectBoundingBox = file.projectType == 'Comprehend NER' || file.projectType == 'OCR';
                        descriptor.comprehendBlocks = file.comprehendData.blocks;
                        // descriptor.comprehendData = file.comprehendData;
                        if( descriptor.text_attributes ) {
                            descriptor.text_attributes.links = [];
                            descriptor.text_attributes.blocks = [];
                            descriptor.text_attributes.attributes = {};
                        }
                        
                        if (!file.comprehendData.blocks) {
                            let res = await window.post('task_comprehend_blocks', { fileId: fileId, itemId: file.itemId });
                            descriptor.comprehendBlocks = res.data.blocks;
                            if (res.data.keyPairs) {
                                // alert( res.data.keyPairs )

                                descriptor.ocrKeyPairData = res.data.keyPairs;
                            }
                        }
                        if (file.projectType == 'OCR' || file.projectType == 'Comprehend NER') {
                            if (file.projectType == 'OCR') {
                                descriptor.ocrMode = true;
                            }
                            if (descriptor.allowTableMode) descriptor.ocrTableMode = true;
                            let res = await window.post('task_keypair_blocks', {
                                fileId: fileId,
                                itemId: file.itemId || null,
                                datasetId: file.datasetId || null,
                            });
                            if (isarray(res.data))
                                descriptor.ocrKeyPairData = res.data;
                            else {
                                descriptor.ocrKeyPairData = res.data.key_value_pairs || [];
                                descriptor.ocrTableData = res.data.table_values || [];
                            }
                        }
                    }
                  else if( file.projectType == 'TEXT_QA' || file.projectType == 'Content Generation' ) {
                        descriptor.labels = {};
                        let qn = 1;
                          // TEXT_QA 
                        if( file.projectType == 'TEXT_QA' ) {
                        if( descriptor.questions ) descriptor.allQuestions = descriptor.questions;
                        console.log('descriptor.questions = file.questions -->',file.questions);
                        
                        descriptor.questions = file.questions || {};
                        for( let q in descriptor.questions ) {
                            let qo = descriptor.questions[q];
                            let k = qo.summary ? 'S' : 'Q';
                            let nm = k+':'+q;
                            let l = {
                                name: nm,
                                color: qo.color,
                                summary: qo.summary,
                                path: [nm],
                                spath: nm,
                            }
                            descriptor.labels[nm] = l;
                            if( !qo.summary ) {
                                let nm = 'A:'+q;
                                let l = {
                                    name: nm,
                                    color: qo.color,
                                    summary: qo.summary,
                                    path: [nm],
                                    spath: nm,
                                }
                                descriptor.labels[nm] = l;
                            }
                        }
                           }
                        descriptor.qaMode = true;
                }
                      else if( file.projectType == 'Content Generation' ) {
                    // Content Generation - only UI setup, no questions processing
                     descriptor.contentGenerationMode = true;
               console.log('Content Generation mode activated');
               $('.answer_1').hide(); 
               }
                        $('.imgdisplay').removeClass('col-10').removeClass('imgdisplay').addClass('col-6').css({flex:'',flexGrow:'',flexShrink:'',flexBasis:'', maxWidth:'', wwidth: 300});
                        $('#right').removeClass('col-2').addClass('col-6');
                    }
                // }
                // return;
                if (window.GlobalVars.PDFProjectType === 'Response Generation' && file.type === "text/csv") {
                    console.log("file?.csvData?.rows",file?.csvData?.rows);
                    console.log("Response Generation: Using pre-parsed csvData from backend.");

                    // 1. Get the pre-parsed rows and headers from the backend data
                    const rawRows = file?.csvData?.rows || [];
                    const headers = file?.csvHeader || ['prompt', 'res_1', 'res_2']; // Use backend headers or a fallback

                    if (rawRows.length > 0) {
                        // 2. Map the data to the format the UI expects ('prompt', 'response1', 'response2')
                        const formattedData = rawRows.map(row => {
                            return {
                                prompt: row[headers[0]] || '',
                                response1: row[headers[1]] || '',
                                response2: row[headers[2]] || ''
                            };
                        });
                        setAllPrompts(formattedData);

                        // 3. IMPORTANT: Initialize the annotation storage object if it doesn't exist
                        if (!file.responseGenAnnotations) {
                            file.responseGenAnnotations = {};
                        }
                        // Ensure the `responseProject` array has the correct size
                        if (!file.responseGenAnnotations.responseProject || file.responseGenAnnotations.responseProject.length !== formattedData.length) {
                           const newArray = Array(formattedData.length).fill(null).map(() => ({}));
                           // Preserve old data if resizing
                           if (file.responseGenAnnotations.responseProject) {
                               for(let i=0; i < Math.min(file.responseGenAnnotations.responseProject.length, formattedData.length); i++) {
                                   newArray[i] = file.responseGenAnnotations.responseProject[i];
                               }
                           }
                           file.responseGenAnnotations.responseProject = newArray;
                        }

                        // 4. Load the saved progress index
                        const savedIndex = file.responseGenAnnotations?.taskcomplete || 0;
                        setCurrentIndex(savedIndex);
                        console.log(`Loaded task. Current annotation index is: ${savedIndex}`);
                        descriptor.ProjectRpLength = formattedData.length;
                    } else {
                        console.warn("csvData.rows is missing or empty.");
                        setAllPrompts([]);
                    }
                }
                afterDescriptor();
                function afterDescriptor() {
                    var loadfrom = file.myAnnotations || file.annotations;
                    if( window.deeplink && !file.myAnnotations && file.taskAnnotations ) {
                        loadfrom = file.taskAnnotations.find( a => a.email == window.GlobalVars.userEmail  );
                        if( loadfrom ) {
                            loadfrom = loadfrom.annotations;
                            descriptor.blockEdit = true;
                        }
                        else loadfrom = file.annotations || {};
                        // console.log( 'FILE', file, loadfrom )
                    }
                    // console.log( 'FILE', file.source );
                    // console.log( 'loadfrom', loadfrom );
                    // console.log( 'pdfUrl', pdfUrl );
                    if( !descriptor.hasPageAttributes ) descriptor.pageAttributes = null;
                    if( !descriptor.hasAttributes ) descriptor.attributes = null;
                    if( loadfrom )
                    {
                        ['tags','links','boxes','tables','classifications', 'attributes','pageAttributes','review','elapsedTime','jobStart','questions','Entities'].forEach( l => {
                            if( loadfrom[l] ) descriptor.text_attributes[l] = loadfrom[l];
                        });
                        // if( loadfrom.metadata ){
                        //     for( var m in loadfrom.metadata ) descriptor.text_attributes.metadata[m] = loadfrom.metadata[m];
                        // }
                    }
                    // console.log( 'ANNOTATEDTAGS', clone(descriptor.text_attributes.tags) )
                    if(!descriptor.text_attributes.attributes ) descriptor.text_attributes.attributes = {tags:[],links:[]}
                    // alert( descriptor.text_attributes.tags.length)


                    // console.log( 'LOADFROMLOADFROMLOADFROMLOADFROMLOADFROMLOADFROMLOADFROMLOADFROMLOADFROMLOADFROMLOADFROM', loadfrom, descriptor.text_attributes )
                    if( 1 && file.modelRuns ) {
                        let hasTags = descriptor.text_attributes.tags.length > 0;
                        let hasAdj = false;
                        if( !descriptor.labels ) descriptor.labels = {};
                        for( let mr of file.modelRuns ) {
                            if( isstring(mr) ) continue;
                            if( !mr.length ) continue;
                            // if( hasAdj ) break;
                            for( let m of mr ) if( !descriptor.labels[m.type] ) descriptor.labels[m.type] = {};
                            if( !hasTags ) {
                                let mid = 1;
                                for( let m of mr ) m.id = mid++;
                                descriptor.text_attributes.tags = mr;
                                hasTags = true;
                            } else {
                                hasAdj = true;
                                let mid = 100000;
                                for( let m of mr ) {
                                    m.type = '#adj#'+m.type
                                    m.id = mid++;
                                    m.adjutication = 1;
                                    descriptor.text_attributes.tags.push( m )
                                }
                            }
                        }
                        descriptor.modelRunMode = true;
                        if (!descriptor.metadata) descriptor.metadata = {};
                        try {
                            descriptor.metadata.ModelRun = window.getParams().modelRun.join(', ')
                        }
                        catch (e) { console.error(e) }
                    }
                    // console.log( 'process.env.PUBLIC_URL', process.env.PUBLIC_URL, file.adlUrl )
    
                    // console.log( 'FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF', file )
                    if (file.type && file.type.match(/image/)) {
                        var url = file.adlUrl || file.signedUrl;
                        if( url.match(/localhost/) ) url = url.replace( /localhost/, document.location.hostname );
                        descriptor.image = {
                            url: url,
                        };
                        console.log( 'IMAGEURL', descriptor.image.url+'&thumbnail=100' )
                    }
                    ///////// VIDEO HERE IN  //////////////////////////////////////////////////////////////
                    /// 
                    /// Add here option when file.type is video. Create descriptor.video similar to image above
                    else if(file.type && file.type.match(/video/)) {
                        var url = file.adlUrl || file.signedUrl;
                        if( url.match(/localhost/) ) url = url.replace( /localhost/, document.location.hostname );
                        descriptor.video = {
                            url: url,
                        };
                        console.log( 'VIDEOURL', descriptor.video.url+'&thumbnail=100' )
                    }
                    ///
                    ///////// VIDEO HERE OUT //////////////////////////////////////////////////////////////
                    else if (file.type == "text/plain" ) {
                        descriptor.htmlText = { pages: [file.preview] };
                    }
                    else if (file.type == "text/csv") {
                        console.log("file-------->", file);
                        window.filesource = file;
                        descriptor.htmlText = { pages: [file.preview] };
                    }
                    else if (file.signedUrl) {
                        var pdfUrl = file.signedUrl;
                        if( pdfUrl.match(/localhost/) ) pdfUrl = pdfUrl.replace( /localhost/, document.location.hostname );
                        descriptor.pdf = {
                            url: pdfUrl,
                            "offsetText": [0, 0],
                        };
                        if( file.pdfJson ) {
                            descriptor.pdf.pdfJson = file.pdfJson;
                        }
                    }
                    else if (file.adlUrl) {
                        var pdfUrl = file.adlUrl;
                        if( pdfUrl.match(/localhost/) ) pdfUrl = pdfUrl.replace( /localhost/, document.location.hostname );
                        descriptor.pdf = {
                            url: pdfUrl,
                            pdfJson: file.pdfJson,
                            "offsetText": [0, 0],
                        };
                        // alert( file.pdfJson );
                        // console.log( 'DESCRIPTOR', descriptor );
                    }
        
                    var deskMeta = descriptor.pdf || descriptor.htmlText || descriptor.image || descriptor.video || {};
                    if( !deskMeta.metadata ) deskMeta.metadata = {};
                    
                    if (fileTitle) deskMeta.metadata.Title = fileTitle;
                    if (fileTheme) deskMeta.metadata.Theme = fileTheme;

                    if( file.name ) deskMeta.metadata.File = file.name;
                    // if( window.hasPriv( 'admin', 'c_admin', 'c_super') ) deskMeta.metadata.TaskId = file.fileId;
                    if( file.fileId ) deskMeta.metadata.TaskId = file.fileId;
                    else if( file.itemId ) deskMeta.metadata.ItemId = file.itemId;
                    if( file.metadata ) for( var m in file.metadata ) deskMeta.metadata[m] = file.metadata[m];
                    if( descriptor.metadata ) {
                        for( var m in descriptor.metadata ) deskMeta.metadata[m] = descriptor.metadata[m];
                    }
                    delete deskMeta.source_ref;
        
        
                    // if( !window.GlobalVars.PDFRole ) descriptor.blockEdit = true;
                    descriptor.reviewMode = file.state == 3;
                    descriptor.reviewMayRequestAdjustment = file.userEmail > '' && descriptor.qcMayRequestAdjustment;
                    descriptor.task_can_decline = true;

                    if( window.deeplink.length ) {
                        $('.top_switch').hide()
                    }


                    // claim-release stuff
                    // descriptor.task_can_claim = (descriptor.fullListMode || false) && (file.state == 0 || file.state==2);
                    descriptor.task_can_claim = (
                        ( valueIn(file.state, [0,2,4,5,7,8]) && window.hasPriv('admin', 'c_admin','c_super')) || 
                        (file.state==0  && window.hasPriv('nlp_an')) ||
                        (file.state==2  && window.hasPriv('nlp_qc'))
                    );
                    descriptor.task_can_release = (descriptor.fullListMode || false);
                    if( descriptor.task_can_release ) {
                        if( file.userEmail == window.GlobalVars.userEmail && file.state > 1 ) descriptor.task_can_release = false;
                        else if( file.qcEmail == window.GlobalVars.userEmail && file.state < 2 ) descriptor.task_can_release = false;
                    }
                    if( datasetDetail ) {
                        descriptor.task_can_claim = descriptor.task_can_release = false;
                        descriptor.blockEdit = true;
                    }
                    descriptor.task_orig_state = file.state;
                    // descriptor.task_role = valueIn(file.state, [0,6,7]) ? 'Annotator' : 'Reviewer';
                    descriptor.task_role = valueIn(file.state, [0, 1, 6, 7]) || descriptor.disableQC ? 'Annotator' : 'Reviewer';
                    descriptor.messages = file.messages || []
                    
                    try {
                        var role = window.GlobalVars.PDFRole || 'nlp_an';
                        var emailcheck = file.state >= 2 && file.state <= 3 ? 'qcEmail' : 'userEmail';
                        var currEmail = file[emailcheck][file[emailcheck].length - 1]
                        descriptor.blockEdit = currEmail != window.GlobalVars.userEmail;
                        if ([0, 1, 2, 3, 6].indexOf(file.state) == -1) descriptor.blockEdit = true;
                    }
                    catch (e) { }
    
                    if( descriptor.task_can_claim && window.deeplink ) descriptor.task_auto_claim = true;
                    descriptor.submit = submitAnnotations;
                    console.log('before updateAnnotations', descriptor)
                    descriptor.update = updateAnnotations;
                    descriptor.claimCallback = claimCallback;
                    descriptor.releaseCallback = releaseCallback;

                    // claim-release stuff end

                    // console.log( 'descriptor', window.clone(descriptor), window.GlobalVars.PDFRole );
                    nlp.loading('preparing task');
                    clearTimeout( initTid )
                    initTid = setTimeout( function(){
                        $(window).scrollTop(0)

                        nlp.init(descriptor);

                    },100 )
                    setDescriptorTasker(descriptor);
                    setIsInitialized(true);
                }
            } catch(e) {
                console.error( e )
                // error();
            }
        }).catch(err => {
    console.error("Failed to load file data:", err);
    frm.myAlert('Task Error', 'Failed to load initial task data. Please check the console for details.');
    nlp.loadingOut(); // Make sure to hide the loader on failure
});;
    },[]);
    useEffect(() => {
    if (descriptorTasker && typeof descriptorTasker.blockEdit !== "undefined") {
        if (descriptorTasker.blockEdit === false) {
            $("#Responseren").show();
        } else {
            $("#Responseren").hide();
        }
    }
    }, [descriptorTasker]);
    
    const updatePersistentIndex = (newIndex) => {
        if (window.GlobalVars.PDFProjectType === 'Response Generation' && responserRef.current) {
            if (!responserRef.current.validateDropdowns()) {
                return;
            }
        }
        if (newIndex < 0 || newIndex >= allPrompts.length) return;
        const descriptor = window.Utterancedata?.descriptor;
        if (descriptor) {
            descriptor.taskcomplete = newIndex;
            if (typeof window.updateAnnotations === 'function') window.updateAnnotations();
        }
        setCurrentIndex(newIndex);
    };
    const updatePersistentIndexprev = (newIndex) => {
        
        if (newIndex < 0 || newIndex >= allPrompts.length) return;
        const descriptor = window.Utterancedata?.descriptor;

        if (descriptor) {
            descriptor.taskcomplete = newIndex;
            if (typeof window.updateAnnotations === 'function') window.updateAnnotations();
        }
        setCurrentIndex(newIndex);
    };
    const projectLength = allPrompts.length;
    return (
        <div fluid="md p-0" className="maincontent">
        <div id="myModal" className="modal fade" role="dialog" style={{zIndex:100000}}>
            <div className="modal-dialog">

                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close myclose" data-dismiss="modal">&times;</button>
                        <h4 className="modal-title">Modal Header</h4>
                    </div>
                    <div className="modal-body">
                        <p>Some text in the modal.</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" id="modal-close" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" id="modal-close2" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" id="modal-close3" className="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>

            </div>
        </div>

        <div className="row">
            <div className="tools"></div>
            <div className="tools-panel hidden">
                    <div className="tool-button" idx="help" title="Hot Keys Help"> <span><img className="" src="imgs/help.svg"/></span></div> 
                    <div className="tool-button" idx="zoomout"><span><img className="" src="imgs/zoom-out.svg"/></span></div>
                <div className="tool-button" idx="zoomin"><span><img className="" src="imgs/zoom-in.svg"/></span></div>
                <span className="ml-4 textoffset">Text position</span>
                <div className="tool-button textoffset" idx="up"><i className="fa fa-arrow-up" aria-hidden="true"></i></div>
                <div className="tool-button textoffset" idx="dn"><i className="fa fa-arrow-down" aria-hidden="true"></i></div>
                <div className="tool-button textoffset" idx="left"><i className="fa fa-arrow-left" aria-hidden="true"></i></div>
                <div className="tool-button textoffset" idx="right"><i className="fa fa-arrow-right" aria-hidden="true"></i></div>
                <span id="cktexts" className="ckbutton tool-button" title="show text positions">
                    <input type="checkbox" id="showTexts"/>
                    {/* <span><i className="fa fa-file-text"></i></span>  mani*/}
                    <span><img className="ml-1" src="imgs/text.svg" /></span>
                    
                </span>
                <span id="ckadjudication" className="ckbutton tool-button" title="show adjudication">
                    <input type="checkbox" id="showAdjudication"/>
                    <span><i className="fa fa-check"></i></span>
                    
                </span>
                <span id="cklabels" className="ckbutton adjcheck tool-button" title="show labels">
                    <input type="checkbox" id="showTags"/>
                    {/* <span><i className="fa fa-tags"></i></span> */}
                    <span><img className=" " src="imgs/tag.svg" /></span>
                </span>
                <span id="ckrelationships" className="ckbutton adjcheck tool-button" title="show relationships">
                    <input type="checkbox" id="showLinks"/>
                    {/* <span><i className="fa fa-link"></i></span> mani */}
                        <span><img className=" " src="imgs/link.svg" /></span>
                    
                </span>
                <span id="cktables" className="ckbutton adjcheck tool-button" title="toggle table mode">
                    <input type="checkbox" id="showTables"/>
                    {/* <span><i className="fa fa-table"></i></span> */}
                    <span><img className=" " src="imgs/bx_table.svg" /></span>
                </span>  
                <span id="ckboxes" className="ckbutton adjcheck tool-button" title="toggle box mode">
                    <input type="checkbox" id="showBoxes"/>
                    {/* <span><i className="fa fa-object-ungroup"></i></span> */}
                    <span><img className=" " src="imgs/bi_bounding-box.svg" /></span>
                </span>
                <span id="showSummary" className="cckbutton adjcheck tool-button" title="show annotation summary">
                    {/* <span><i className="fa fa-list-ul"></i></span> */}
                    <span><img className=" " src="imgs/list.svg" /></span>
                </span>
                {/* mani */}
                <span id="chatbox" className="cckbutton adjcheck tool-button" title="">
                    {/* <input type="checkbox" id="showBoxes"/> */}
                    <span><img className=" " src="imgs/chat.svg" /></span>
                    <div id="chat_notification" className="notification"></div>
                </span>
                <div className="searchbox">
                    <div className="input-group">
                        <div className="form-outline searchinput">
                            <input type="search" id="pdfsearch" className="form-control glueright" placeholder="Search"/>
                        </div>
                        <div className="btn-group searchbuttons" data-toggle="buttons">
                            <button type="button" id="sbtnsearch" className="btn btn-secondary ssearchbtn glueleft roundright">
                                <i className="fa fa-search"></i>
                            </button>
                            <span id="sbtnresult" className="btn btn-secondary searchresult">1/14</span>
                            <button type="button" id="sbtnup" className="btn btn-secondary searchbtn">
                                <i className="fa fa-angle-up"></i>
                            </button>
                            <button type="button" id="sbtndown" className="btn btn-secondary searchbtn">
                                <i className="fa fa-angle-down"></i>
                            </button>
                            <button type="button" id="sbtnclose" className="btn btn-secondary searchbtn">
                                <i className="fa fa-close"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="legends"></div>
                <div className="button-group">
                <button id="submitButton" type="submit" className="ml-3 mt-2 btn btn-primary"><i class=" mr-2 fa fa-check-circle-o" aria-hidden="true"></i>Submit </button>
                <button id="resumeLater" type="submit" className="mr-2 btn btn-pink task-button"> <i class=" mr-2 fa fa-floppy-o" aria-hidden="true"></i>Save & Exit</button>
                </div>
                {window.GlobalVars.PDFProjectType === 'Response Generation' && projectLength > 1 && (
                        <div id="Responseren" style={{ display: "none", position: "absolute", right: "0px", paddingTop: "6px", paddingRight: '6px' }}>
                            <button id="prevPrompt" className="btn btn-light btn-sm mr-2" disabled={currentIndex === 0} onClick={() => updatePersistentIndexprev(currentIndex - 1)} > <i className="fa fa-backward prev" style={{ color: "#7367f0" , fontSize: "20px",}}></i> </button>
                            <span  style={{ Color: "black"}}> Prompt {currentIndex + 1} of {projectLength} </span>
                            <button id="nextPrompt" className="btn btn-light btn-sm ml-2" disabled={currentIndex >= projectLength - 1} onClick={() => updatePersistentIndex(currentIndex + 1)} >  <i className="fa fa-forward next" style={{ color: "#7367f0" , fontSize: "20px",}}></i></button>
                        </div>  
                         
                    )}
                
                {/* </div> */}

                <div className="nlp-pagination" style={{display:'none'}}>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="imgdisplay">
            </div>

        </div>
        {(window.GlobalVars.PDFProjectType !== 'Response Generation') && (<div className="row" id="pdfrow">
                <div className="col-10 imgdisplay">
                    <div className="row" style={{position:'relative'}}>

                    	<div className="col-12  scroll-thinn" id="maincolumn">
                            <div id="pdfinfo"></div>
                            <canvas id="img-layer"></canvas>
                            <div id="box-layer"></div>
                            <div id="text-layer"></div>
                        </div>
                    </div>
                </div>
                <div id="right" className="col-2 ctrlpanel scroll-thin" style={{height: '50%', overflowY:'scroll'}}>
                    <div id="findresults" className="find-result">Find Results</div>
                    <div id="messages" className="file-messages"></div>
                    <div className="mt-2" id="submitReviewer">
                        <div id="reviewer-fields">
                        <div id="reviewer-opts">

                        </div>
                        <textarea id="reviewer_notes" className="inote-text mt-2" placeholder="Reviewer Notes"></textarea>
                        </div>
                        <textarea id="annotator_notes" className="inote-text mt-2" placeholder="Annotator Notes"></textarea>
					</div>

                    <div className="mt-2" id="page_attrs"></div>
                    <div id="classification"></div>
                    <div id="labels"></div>
                    <div id="relationships"></div>
                    <div id="boxeskeys"></div>
                    <div className="mt-2" id="text_attrs"></div>

                </div>
        </div>)}
        {window.GlobalVars.PDFProjectType == 'Response Generation' && descriptorTasker && (
                <div className="row" id="pdfrow">
                    <div className={descriptorTasker.task_role == "Reviewer" ? "col-10 imgdisplay" : "col-12"}>
                        <div className="row" style={{ position: 'relative' }}>
                            <div className="col-12 scroll-thinn" id="maincolumn">
                                <div id="pdfinfo"></div>
                                <canvas id="img-layer"></canvas>
                                <div id="box-layer"></div>
                                <div id="text-layer" style={{ display: "none" }}></div>
                                <div id="Responser-layer">
                                    <Responser
                                        ref={responserRef}
                                        currentIndex={currentIndex}
                                        allPrompts={allPrompts}
                                    />
                                </div>

                            </div>
                        </div>
                    </div>

                    <div id="right" className="col-2 ctrlpanel scroll-thin" style={{ height: '50%', overflowY: 'scroll' }}>
                        <div id="findresults" className="find-result">Find Results</div>
                        <div id="messages" className="file-messages"></div>
                        <div className="mt-2" id="submitReviewer">
                            <div id="reviewer-fields">
                                <div id="reviewer-opts"></div>
                                <textarea id="reviewer_notes" className="inote-text mt-2" placeholder="Reviewer Notes"></textarea>
                            </div>
                            <textarea id="annotator_notes" className="inote-text mt-2" placeholder="Annotator Notes"></textarea>
                        </div>

                        <div className="mt-2" id="page_attrs"></div>
                        <div id="classification"></div>
                        <div id="labels"></div>
                        <div id="relationships"></div>
                        <div id="boxeskeys"></div>
                        <div className="mt-2" id="text_attrs"></div>
                    </div>
                </div>)}
        </div>

    )
}

export default NlpViewer
